/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningscolumnpayout2Inputs */

const en_earningscolumnpayout2 = /** @type {(inputs: Earningscolumnpayout2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payout`)
};

const de_earningscolumnpayout2 = /** @type {(inputs: Earningscolumnpayout2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszahlung`)
};

/**
* | output |
* | --- |
* | "Payout" |
*
* @param {Earningscolumnpayout2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningscolumnpayout2 = /** @type {((inputs?: Earningscolumnpayout2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningscolumnpayout2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningscolumnpayout2(inputs)
	return de_earningscolumnpayout2(inputs)
});
export { earningscolumnpayout2 as "earningsColumnPayout" }